import { useState } from "react";
import PageScanRequestFilterCard from "./PageScanRequestFilter/PageScanRequestFilterCard";
import PageScanRequestTable from "./PageScanRequestTable/PageScanRequestTable";

import { QuarterlySpeedGoalsEndPointLogic } from "../../../../../logic/AssetManagement/Health/Quarterly Website Speed Goals/QuarterlySpeedGoalsEndPointLogic";
import { useDispatch } from "react-redux";
import TableSkeleton from "../../../../TableSkeleton";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../features/userSlice";
import {
  setAddNewPageReqText,
  setPageScanData,
} from "../../../../../features/pageSpeedPerformanceSlice";

function PageScanRequest() {
  const { selectedSharedUid, pageScanData, pageScanDataLoading } = useSelector(
    (state: any) => state.pageSpeedPerformance
  );
  const token = useSelector(selectUserToken) as any;
  const [postedPageSpeedContent, setPostedPageSpeedContent] = useState<any[]>(
    []
  );
  const [errorAccToPageStatus, setErrorAccToPageStatus] = useState([]);
  const [selectedSearchValue, setSelectedSearchValue] = useState(null);
  const dispatch = useDispatch();

  const updatePageScanData = (data: any[]) => {
    dispatch(setPageScanData(data));
  };

  const tableHeadings = {
    page_name: "Page Name",
    active: "Scan Status",
    tests_amount: "Scan Count",
    last_run: "Last Scan",
    created: "Requested On",
    created_by: "Requested By",
  };

  const postPageSpeed = async (data: any): Promise<boolean> => {
    try {
      if (token) {
        let success = false;
        await QuarterlySpeedGoalsEndPointLogic.postPageSpeedInternal(
          token,
          data,
          selectedSharedUid,
          (res: any) => {
            setPostedPageSpeedContent(res);
            success = true;
          },
          setErrorAccToPageStatus
        );
        if (success) {
          dispatch(setAddNewPageReqText(""));
          await QuarterlySpeedGoalsEndPointLogic.getPageViewInternalList(
            token,
            selectedSharedUid,
            updatePageScanData,
            dispatch
          );
          return true;
        }
        return false;
      }
      return false;
    } catch (error) {
      console.error("Error posting or fetching page speed data:", error);
      return false;
    }
  };

  return (
    <>
      <PageScanRequestFilterCard
        selectedSearchValue={selectedSearchValue}
        setSelectedSearchValue={setSelectedSearchValue}
        rows={pageScanData ?? []}
        setErrorAccToPageStatus={setErrorAccToPageStatus}
        postedPageSpeedContent={postedPageSpeedContent}
        errorAccToPageStatus={errorAccToPageStatus}
        postPageSpeed={postPageSpeed}
      />
      {pageScanDataLoading ? (
        <TableSkeleton rows={10} columns={7} />
      ) : (
        <PageScanRequestTable
          setPageInternalListData={updatePageScanData}
          selectedSearchValue={selectedSearchValue}
          tableHeadings={tableHeadings}
          rows={pageScanData ?? []}
          loading={false}
        />
      )}
    </>
  );
}

export default PageScanRequest;
